<h2 mat-dialog-title>Roller SOAP – getTouren</h2>

<mat-dialog-content class="roller-soap-import-content">
  <p class="hint">
    Lädt gebuchte Aufträge aus dem Roller-Logistikportal für Filiale und Datum (wie Roller API in Stats).
  </p>

  <div class="form-group" *ngIf="branches.length">
    <label for="rollerSoapBranchSelect">Filiale aus MH3</label>
    <select
      id="rollerSoapBranchSelect"
      class="form-control"
      #branchSelect
      (change)="onBranchSelected(branchSelect.value ? +branchSelect.value : null)"
    >
      <option value="">– Filiale wählen –</option>
      <option
        *ngFor="let branch of branches"
        [value]="branch.id"
        [selected]="branch.short === branchNo"
      >
        {{ branch.label }}
      </option>
    </select>
  </div>

  <div class="form-group">
    <label for="rollerSoapBranchNo">Filiale (branchNo)</label>
    <input
      id="rollerSoapBranchNo"
      type="text"
      class="form-control"
      maxlength="2"
      [(ngModel)]="branchNo"
      placeholder="z. B. 70"
    >
    <small class="form-text text-muted">2-stellige Roller-Filialnummer</small>
  </div>

  <div class="form-group mb-0">
    <label for="rollerSoapDate">Datum (calendarDay)</label>
    <input
      id="rollerSoapDate"
      type="date"
      class="form-control"
      [(ngModel)]="terminDate"
    >
  </div>

  <div class="alert alert-warning mt-3 mb-0 py-2" *ngIf="validationError">{{ validationError }}</div>

  <div class="soap-preview-block" *ngIf="soapEnvelopePreview">
    <label class="soap-preview-label">SOAP-Request (Vorschau zum Prüfen)</label>
    <pre class="soap-preview-body">{{ soapEnvelopePreview }}</pre>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button type="button" class="btn btn-outline-secondary" (click)="cancel()">Abbrechen</button>
  <button type="button" class="btn btn-primary" (click)="confirm()">OK</button>
</mat-dialog-actions>
